import classNames from "classnames";
import { ReactNode } from "react";

import css from "../input_field_set.module.scss";

type IconProps = { className?: string; icon: ReactNode };

export const Icon = ({ icon, className }: IconProps) => (
  <div className={classNames(css.icon, className)}>{icon}</div>
);
